
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToForm = () => {
    const formElement = document.getElementById('contractor-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative bg-gradient-to-br from-blue-50 to-white py-20 lg:py-32 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/f79f6f8c2f4f6466ebb0ca84dd88c7ae.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="absolute inset-0 bg-white/85"></div>
      
      {/* Quote Value Banner */}
      <div className="relative bg-blue-600 text-white py-3 px-4 text-center">
        <div className="flex items-center justify-center space-x-3 text-sm font-medium">
          <i className="ri-lightbulb-line text-blue-200"></i>
          <span>Smart Planning: See what your project actually costs before making any decisions</span>
          <span className="bg-white/20 px-3 py-1 rounded-full">Knowledge is power</span>
          <i className="ri-calculator-line text-blue-200"></i>
        </div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="w-full space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Connecticut's Trusted
                <span className="text-blue-600 block">Bathroom Contractor Network</span>
              </h1>
              
              <p className="text-xl text-gray-700 leading-relaxed">
                We connect homeowners with verified, licensed bathroom contractors across Connecticut. 
                Get detailed quotes to understand exactly what your project will cost - no surprises, no pressure.
              </p>
              
              <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <i className="ri-shield-check-line text-green-600 text-lg"></i>
                  <span>Connecticut Licensed</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-star-fill text-yellow-500 text-lg"></i>
                  <span>4.5+ Star Rating</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-eye-line text-blue-600 text-lg"></i>
                  <span>Transparent Pricing</span>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-green-50 to-blue-50 border-l-4 border-green-500 p-4 rounded">
              <div className="flex items-center">
                <i className="ri-information-line text-green-600 text-xl mr-3"></i>
                <div>
                  <p className="font-semibold text-green-800">Why Get a Quote First?</p>
                  <p className="text-green-700 text-sm">Smart homeowners get quotes to budget properly, compare options, and avoid overpaying. Even if you're not ready now, you'll know exactly what to expect when you are.</p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button onClick={scrollToForm} size="lg" className="text-lg px-10 bg-blue-600 hover:bg-blue-700">
                <i className="ri-calculator-line mr-2"></i>
                See What It Costs
              </Button>
              <Button variant="outline" size="lg" className="text-lg border-blue-500 text-blue-600 hover:bg-blue-50">
                <i className="ri-information-line mr-2"></i>
                Learn More
              </Button>
            </div>
            
            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600 mb-3">Why Connecticut homeowners get quotes first:</p>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="flex items-center space-x-2">
                  <i className="ri-money-dollar-circle-line text-green-600"></i>
                  <span>Budget with confidence</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-shield-line text-blue-600"></i>
                  <span>Avoid contractor surprises</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-bar-chart-line text-purple-600"></i>
                  <span>Compare your options</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-time-line text-orange-600"></i>
                  <span>Plan your timeline</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hidden lg:block">
            {/* Right side content area - image will be background */}
          </div>
        </div>
      </div>
    </section>
  );
}
